/*
 * @Author: YuanYuan
 * @Date: 2024-02-04 19:44:22
 * @LastEditTime: 2025-11-27 20:02:26
 * @Description: 入口文件
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from '@/i18n'
import inject from '@/plugins/inject'
import { initProject } from '@/utils/initProject'
import globalComponents from '@/components/global/index'
import '@/styles/index.scss'

Vue.config.productionTip = false
Vue.use(window.ELEMENT, { i18n: (key, value) => i18n.t(key, value) })
Vue.use(globalComponents) // 注册全局组件
Vue.use(inject)
initProject()

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
